import styled from "styled-components";
import { COLORS } from "../../../../../../assets/constants/styles";

export const MetadataContainer = styled.div`
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid ${COLORS.lightestViolet};
`;

export const MetadataItem = styled.div`
  margin: 5px 0;
  font-size: 14px;
  color: ${COLORS.grey};
  overflow-wrap: break-word;
  word-break: break-word;
  display: flex;
`;

export const MetadataLabel = styled.span`
  font-weight: 600;
  margin-right: 5px;
`;

export const MetadataValue = styled.span`
  flex: 1;
`;
